export default "__VITE_ASSET__BLAGGDmQ__"